import { type FunctionalComponent, h } from '@stencil/core';


export interface GenericCardCtaBottomSection {
    hideSection?:boolean;
    hideDivider?:boolean;
}

export const GenericCardCtaBottomSection: FunctionalComponent<GenericCardCtaBottomSection> = (
  props , children
) => {
    const {
      hideSection,
      hideDivider
    } = props;

    return !hideSection ? (
      <div class="card-bottom-section">
        {!hideDivider && <qds-divider
          class="product-card__divider--alternative"
        />}
        <section class={'card-bottom-section-cta'}>
          {children}
        </section>
      </div>
    ) : (
      ''
    );
};
